import "./Packages.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonType } from "../Button";
import { ResellerPackageType } from "../../features/Resellers/PackageType";

const ViewPackages = ({
	selectedPackages,
	onRemovePackage,
	onSelectPackage,
	altTitle = "Packages",
	onClose,
	hidePrices = false,
}) => {
	return (
		<div className={`view-packages ${onSelectPackage ? "select-packages" : ""}`}>
			<div className="view-packages-header">
				<h4>{altTitle}</h4>
				{onClose && (
					<div className="view-packages-header-close" onClick={onClose}>
						<FontAwesomeIcon icon={faTimes} />
					</div>
				)}
			</div>
			{selectedPackages.map((pkg, index) => (
				<div className="package-card" key={index}>
					<div className="package-card-header">
						<h4>{pkg.Name}</h4>
						{onRemovePackage && (
							<div className="package-actions">
								{pkg.CanDelete === true && (
									<FontAwesomeIcon
										icon={faTrash}
										className="icon-trash"
										onClick={() => onRemovePackage(pkg.Id)}
									/>
								)}
							</div>
						)}
					</div>

					<div className="package-details">
						{pkg.PackageType !== ResellerPackageType.SingleUnlimitedUsers && (
							<div className="package-details-detail">
								<p className="title">Type</p>
								<p>{pkg.PUP ? "PUP" : "PCP"}</p>
							</div>
						)}

						{pkg.SeatQuantity && pkg.PackageType !== ResellerPackageType.SingleUnlimitedUsers && (
							<div className="package-details-detail">
								<p className="title">Seats</p>
								<p>{pkg.PackageType === ResellerPackageType.SingleUnlimitedUsers ? "Unlimited" : pkg.SeatQuantity * pkg.SeatBlockSize}</p>
							</div>
						)}

						{pkg.SeatBlockSize && !pkg.PUP && !pkg.SeatQuantity && (
							<div className="package-details-detail">
								<p className="title">Seats per Package</p>
								<p>{pkg.PackageType === ResellerPackageType.SingleUnlimitedUsers ? "Unlimited" : pkg.SeatBlockSize}</p>
							</div>
						)}

						{pkg.LevelName && (
							<div className="package-details-detail">
								<p className="title">Level</p>
								<p>{pkg.LevelName}</p>
							</div>
						)}

						{!hidePrices && (
							<>
								{pkg.LevelPrice > 0 && (
									<div className="package-details-detail">
										<p className="title">Level Price</p>
										<p>£{pkg.LevelPrice}</p>
									</div>
								)}

								{pkg.OnboardingPrice > 0 && (
									<div className="package-details-detail">
										<p className="title">Onboarding Price</p>
										<p>£{pkg.OnboardingPrice}</p>
									</div>
								)}

								{pkg.Price > 0 && (
									<div className="package-details-detail">
										<p className="title">Price</p>
										<p>£{pkg.Price}</p>
									</div>
								)}

								{pkg.UpsellPrice > 0 && (
									<div className="package-details-detail">
										<p className="title">Upsell Price</p>
										<p>£{pkg.UpsellPrice}</p>
									</div>
								)}
							</>
						)}

						{!pkg.LevelName &&
							(pkg.BronzePrice > 0 ||
								pkg.SilverPrice > 0 ||
								pkg.GoldPrice > 0 ||
								pkg.PlatinumPrice > 0) && (
								<div className="package-details-tiers">
									<h5>{hidePrices ? "Available Levels" : "Level"}</h5>
									<div className="package-details-tiers-grid">
										{pkg.BronzePrice > 0 && (
											<p>
												<span>Bronze</span>
												{!hidePrices && <> £{pkg.BronzePrice}</>}
											</p>
										)}
										{pkg.SilverPrice > 0 && (
											<p>
												<span>Silver</span>
												{!hidePrices && <> £{pkg.SilverPrice}</>}
											</p>
										)}
										{pkg.GoldPrice > 0 && (
											<p>
												<span>Gold</span>
												{!hidePrices && <> £{pkg.GoldPrice}</>}
											</p>
										)}
										{pkg.PlatinumPrice > 0 && (
											<p>
												<span>Platinum</span>
												{!hidePrices && <> £{pkg.PlatinumPrice}</>}
											</p>
										)}
									</div>
								</div>
							)}

						{onSelectPackage && (
							<div className="package-select">
								<Button
									type={ButtonType.Primary}
									label="Select Package"
									onClick={() => onSelectPackage(pkg)}
								/>
							</div>
						)}
					</div>
				</div>
			))}

			{onSelectPackage && (
				<div className="package-select">
					<Button
						type={ButtonType.Secondary}
						label="Cancel Select Package"
						onClick={onClose}
					/>
				</div>
			)}
		</div>
	);
};

export default ViewPackages;
